<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "toUserPhone":"18200946810",
                "weixinTemplateId":"ngqIpbwh8bUfcSsECmogfXcV14J0tQlEpBO27izEYtY",
                "weixinData":{
                    "first": {
                        "value":"恭喜你购买成功！",
                        "color":"#173177"
                    },
                    "keynote1":{
                        "value":"巧克力",
                        "color":"#173177"
                    },
                    "keynote2": {
                        "value":"39.8元",
                        "color":"#173177"
                    },
                    "keynote3": {
                        "value":"2014年9月22日",
                        "color":"#173177"
                    },
                    "remark":{
                        "value":"欢迎再次购买！",
                        "color":"#173177"
                    }
                },
                appData:"智慧停车，你好",
                url:"http://www.xxx.xin",
                "weixinMiniprogram":{
                        "appid":"xiaochengxuappid12345",
                        "pagepath":"index?foo=bar"
                }


           },
            responseCode: {"data":{},"message":"业务成功","resultCode":0,"status":1}	,
            infoData: {
                explain: "通过此接口可发送消息给智慧停车用户(微信消息参考地址:https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1433751277)",
                t_url: this.commonUrls.test+"sendMsgToYdtUser",
                p_url: this.commonUrls.prod+"sendMsgToYdtUser",
                precondition: "无",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'toUserPhone', info2: '是', info3: 'String', info4: '智慧停车用户接受者的手机号' },
                        { info1: 'weixinTemplateId', info2: '否', info3: 'String', info4: '模板ID' },
                        { info1: 'weixinData', info2: '否', info3: 'JSONObject', info4: '微信模板数据,需与微信模板消息一致(与APP显示数据不能同时为空)' },
                        { info1: 'appData', info2: '否', info3: 'String', info4: 'APP显示数据(与微信模板数据不能同时为空)' },
                        { info1: 'url', info2: '否', info3: 'String', info4: '跳转链接,如果传了weixinMiniprogram，优先跳转小程序' },
                        { info1: 'weixinMiniprogram', info2: '否', info3: 'JSONObject', info4: '跳小程序所需数据，不需跳小程序可不用传该数据' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/sendMsgToYdtUser.vue